import styled, { keyframes } from 'styled-components'
import { ReactComponent as BookmarkIconFilled } from 'assets/img/bookmark-icon-filled.svg'

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`

export const DisableBlock = styled.div<{
  width?: number
  height?: number
  radius?: number
}>`
  width: ${(props) => props.width || 66}px;
  height: ${(props) => props.height || 12}px;
  border-radius: ${(props) => props.radius || 8}px;
  background: ${({ theme }) => theme.colors.skeleton.primary};
`

export const FlexBox = styled.div<{
  justify?: string
  align?: string
  direction?: string
}>`
  display: flex;
  align-items: ${(props) => props.align || 'center'};
  justify-content: ${(props) => props.justify || 'center'};
  flex-direction: ${(props) => props.direction || 'row'};
`

export const ReloadIconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 39px;
  height: 33px;
  padding: 0;
  border: none;
  border-radius: 9px;
  background: transparent;
  cursor: pointer;

  .reloadPage {
    animation: ${spin} 1s linear infinite;
  }

  &:disabled {
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.border.info};
    outline-offset: 2px;
  }
`

export const QuestionsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  justify-content: flex-start;
  gap: 7px;
`

export const PageNumberBadge = styled.button<{
  $unsaved?: boolean
  $current?: boolean
  $isTeacherGuide?: boolean
}>`
  width: 22px;
  height: 29px;
  border: 1px solid ${(props) => props.theme.colors.border.primary};
  background-color: ${(props) => props.theme.colors.card.background};
  box-shadow: 1px 1px 0 0 rgba(0, 0, 0, 0.25);
  color: ${(props) => props.theme.colors.text.primary};
  font-family: ${(props) => props.theme.typography.fontInter};
  font-size: ${(props) => (props.$isTeacherGuide ? '13px' : '15px')};
  font-weight: 400;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;

  ${(props) =>
    props.$unsaved &&
    `
    color: #fff;
    background-color: #d32f2f;
    border: 1px solid #d32f2f;
  `}

  ${(props) =>
    props.$current &&
    `
    border: none;
    font-weight: 700;
    color: ${props.theme.colors.text.primary};
    background: none;
    box-shadow: none;
  `}

  &::after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: 1px;
    transform: translateX(-50%);
    width: ${(props) => (props.$current ? '15px' : '0')};
    height: 2px;
    background: ${(props) => (props.$current ? '#bdbdbd' : 'transparent')};
  }

  @media (max-width: 768px) {
    width: 29px;
    height: 29px;
    font-size: 15px;
  }
`

export const QuestionButton = styled.button<{
  $unsaved?: boolean
  $current?: boolean
  $answered?: boolean
}>`
  width: 29px;
  height: 29px;
  border-radius: 40px;
  border: 1px solid ${(props) => props.theme.colors.border.primary};
  background-color: ${(props) => props.theme.colors.card.background};
  box-shadow: 1px 1px 0 0 rgba(0, 0, 0, 0.25);
  color: ${(props) => props.theme.colors.text.primary};
  font-family: ${(props) => props.theme.typography.fontInter};
  font-size: 15px;
  font-weight: 400;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;

  ${(props) =>
    props.$unsaved &&
    `
    color: #fff;
    background-color: #d32f2f;
    border: 1px solid #d32f2f;
  `}

  ${(props) =>
    props.$answered &&
    `
     border: solid 1px ${props.theme.colors.border.success};
     background-color: ${props.theme.colors.surface.success};
     color: #fff;
   `}

  ${(props) =>
    props.$current &&
    `
    border: none;
    font-weight: 700;
    color: ${props.theme.colors.text.primary};
    background: none;
    box-shadow: none;
  `}

  &::after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: 3px;
    transform: translateX(-50%);
    width: ${(props) => (props.$current ? '15px' : '0')};
    height: 2px;
    background: ${(props) => (props.$current ? '#bdbdbd' : 'transparent')};
  }

  @media (max-width: 768px) {
    width: 29px;
    height: 29px;
    font-size: 15px;
  }
`

export const QuestionBookmarkIcon = styled(BookmarkIconFilled)`
  position: absolute;
  filter: drop-shadow(0.5px 0.5px 0 rgba(0, 0, 0, 0.25));
  top: -2px;
  right: -3px;
  width: 10px;
  height: 10px;
  z-index: 2;
  pointer-events: none;
`

export const MutedText = styled.span`
  color: ${(props) => props.theme.colors.text.paragraph};
  font-family: ${(props) => props.theme.typography.fontNunito};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`
